import { render } from "./eidt.vue?vue&type=template&id=1412eeb4&scoped=true&ts=true"
import script from "./eidt.vue?vue&type=script&lang=ts"
export * from "./eidt.vue?vue&type=script&lang=ts"

import "./eidt.vue?vue&type=style&index=0&id=1412eeb4&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1412eeb4"]])

export default __exports__